<template>
	<v-app>

		<Nav/>

		<v-container class="landing-description container-wrapper">

			<v-row
				class="pt-6"
			>
				<v-col
					cols="12"
					class="text-sm-left text-center"
				>
					<h1 class="pb-6">Administravimas</h1>
					<p>
						Aplikacijos pagrindinių parametrų redagavimo ir naudotojų paklausimų administravimo sritis
					</p>

				</v-col>

			</v-row>

			<v-row
				class="pb-6"
			>
				<v-col
					cols="12"
				>

					<v-content>
						<v-tabs
							v-model="tab"
						>
							<v-tab
								v-for="(item, index) in tabs"
								:key="index"
								:class="['px-2', 'caption', index ? '' : 'ml-2', 'mr-1']"
							>
								{{item.title}}
							</v-tab>
							<v-tabs-items v-model="tab">
								<v-tab-item v-for="(item) in tabs" :key="item.component" class="pa-4 pt-5">
									<component :is="item.component"></component>
								</v-tab-item>
							</v-tabs-items>
						</v-tabs>
						<CommonComponents />
					</v-content>

				</v-col>

			</v-row>

		</v-container>

		<v-footer class="white">
			<Footer />
		</v-footer>

	</v-app>
</template>

<script>
	import Nav from "../header/PageNav";
	import Footer from "../footer/FooterTitle";
	import CommonComponents from "../CommonComponents";

	export default {
		data: function(){
			var data = {
				tabs: [{
					title: "Bendrieji nustatymai",
					component: "common-settings"
				},{
					title: "Resursai vartotojams",
					component: "resources-4-users"
                    },{
                        title: "Sukurti atlasai",
                        component: "atlases-4-admin"
                    }],
				tab: 0
			};
			return data;
		},
		components: {
			Nav,
			Footer,
			CommonComponents,
			"common-settings": () => ({
				component: import("../admin/CommonSettings")
			}),
			"resources-4-users": () => ({
				component: import("../admin/Resources4Users")
            }),
            "atlases-4-admin": () => ({
                component: import("../admin/Atlases4Admin")
            })
		}
	};
</script>